export default __webpack_public_path__ + "static/media/setPic.8fea5d76.svg";